var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { Paper } from "@material-ui/core";
import { UsageReportTab } from "./UsageReport";
import { getCurrentYearFirstDay } from "../../common/Validation";
import { UsageReportFilter } from "./UsageReportFilter";
import { ClientUsageReportParams } from "../../helpers/Domain/ViewModels/ClientUsageReportParams";
import { ColumnType } from "../../helpers/Domain/ViewModels/ClientUsageReport";
import { SortingState, SearchState, PagingState, DataTypeProvider, CustomPaging, } from "@devexpress/dx-react-grid";
import { Grid, Table, TableHeaderRow, PagingPanel, Toolbar, SearchPanel, } from "@devexpress/dx-react-grid-material-ui";
import { Template } from "@devexpress/dx-react-core";
var columns = [
    { name: "UserName", title: "User Name" },
    { name: "UserEmail", title: "Email" },
    { name: "LastSend", title: "Last Sent" },
    { name: "Total1040", title: "1040" },
    { name: "Total1041", title: "1041" },
    { name: "Total1065", title: "1065" },
    { name: "Total1120", title: "1120" },
    { name: "Total1120S", title: "1120S" },
    { name: "Total990", title: "990/T" },
    { name: "Total990PF", title: "990PF" },
    { name: "Total990EZ", title: "990EZ" },
    { name: "Total", title: "Total" },
];
var tableColumnExtensions = [
    { columnName: "UserName" },
    { columnName: "Email" },
    { columnName: "LastSend" },
    { columnName: "1040" },
    { columnName: "1041" },
    { columnName: "1065" },
    { columnName: "1120" },
    { columnName: "Total" },
];
var UserUsageReport = /** @class */ (function (_super) {
    __extends(UserUsageReport, _super);
    function UserUsageReport(props) {
        var _this = _super.call(this, props) || this;
        _this.getClientUsageData = function (clientUsageReportParams) {
            var _self = _this;
            _self.props.getClientUsageData(clientUsageReportParams);
        };
        _this.userNameFormatter = function (row) {
            switch (row.row.ColumnType) {
                case ColumnType.PageFooter:
                    return _jsx("strong", __assign({ style: { fontSize: '13px' } }, { children: "Page Total" }));
                case ColumnType.TableFooter:
                    return _jsx("strong", __assign({ style: { fontSize: '13px' } }, { children: "Filter Total" }));
                default:
                    return _jsx("span", __assign({ title: row.row.UserName }, { children: row.row.UserName }));
            }
        };
        _this.userEmailFormatter = function (row) {
            return _jsx("span", __assign({ title: row.row.UserEmail }, { children: row.row.UserEmail }));
        };
        _this.toolBarContent = function () {
            return (_jsxs("span", __assign({ style: { width: "100%" } }, { children: ["Salesforce ID : ", _jsxs("strong", { children: [_this.props.salesForceId, " "] }), " "] })));
        };
        _this.cellFormatter = function (props) {
            return (_jsx(Table.Cell, __assign({}, props, { children: _jsx("span", __assign({ style: { fontSize: '13px' } }, { children: props.value })) })));
        };
        _this.state = {
            filteredRows: [],
            paginatedData: [],
            rows: [],
            selectedTaxSoftware: {},
            selectedDeliveryMode: {},
            pageSize: 20,
            currentPage: 0,
            selection: "",
            searching: "",
            hideTestAccount: true,
            sorting: {},
            selectedCompany: {},
            companies: [],
            totalCount: 0,
        };
        return _this;
    }
    UserUsageReport.prototype.componentDidMount = function () {
        this.getClientUsageData(new ClientUsageReportParams(getCurrentYearFirstDay(), new Date(), this.props.selectedTaxSoftware, UsageReportTab.User, this.props.selectedDeliveryMode, this.props.selectedCompany.value));
    };
    UserUsageReport.prototype.render = function () {
        return (_jsxs("div", __assign({ className: "scroll-bar page-body-container", id: "micro-extension-usage-report" }, { children: [_jsx(UsageReportFilter, { filter: this.props.getClientUsageData, downloadasPdf: this.props.downloadAsPdf, clearfilter: this.props.clearfilter, hideTest: this.props.hideTestCompanies, taxSoftwareList: this.props.taxSoftwareList, handleTaxSoftwareChange: this.props.handleTaxSoftwareChange, selectedTaxSoftware: this.props.selectedTaxSoftware, groupBy: UsageReportTab.User, selectedDeliveryMode: this.props.selectedDeliveryMode, handleDeliveryModeChange: this.props.handleDeliveryModeChange, companies: this.props.companies, selectedCompany: this.props.selectedCompany, handleCompanyChange: this.props.handleCompanyChange }), _jsx(Paper, { children: _jsxs(Grid, __assign({ rows: this.props.rows, columns: columns }, { children: [_jsx(SortingState, { sorting: this.props.sorting, onSortingChange: this.props.changeSorting }), _jsx(DataTypeProvider, { for: ["UserName"], formatterComponent: this.userNameFormatter }), _jsx(DataTypeProvider, { for: ["SalesforceId"], formatterComponent: this.props.salesForceIDFormatter }), _jsx(DataTypeProvider, { for: ["UserEmail"], formatterComponent: this.userEmailFormatter }), _jsx(DataTypeProvider, { for: ["LastSend"], formatterComponent: this.props.lastSentFormatter }), _jsx(DataTypeProvider, { for: [
                                    "Total1040",
                                    "Total1041",
                                    "Total1065",
                                    "Total1120",
                                    "Total1120S",
                                    "Total990",
                                    "Total990PF",
                                    "Total990EZ",
                                    "Total",
                                ], formatterComponent: this.props.countColumnsFormatter }), _jsx(SearchState, { value: this.props.searching, onValueChange: this.props.search }), _jsx(PagingState, { currentPage: this.props.currentPage, onCurrentPageChange: this.props.changeCurrentPage, pageSize: this.props.pageSize }), _jsx(CustomPaging, { totalCount: this.props.totalCount }), _jsx(Table, { columnExtensions: tableColumnExtensions }), _jsx(TableHeaderRow, { showSortingControls: true }), _jsx(PagingPanel, {}), _jsx(Toolbar, {}), _jsx(Template, { name: "toolbarContent", predicate: function () {
                                    return true;
                                }, children: this.toolBarContent }), _jsx(SearchPanel, {})] })) })] })));
    };
    return UserUsageReport;
}(React.Component));
export { UserUsageReport };
